
(function ($) {
    console.log('Hello, World! 1');

   // "use strict";
	

	// var $window = $(window); 
	// var $body = $('body'); 

	/* Preloader Effect */
	// $window.on('load', function(){
	// 	$(".preloader").fadeOut(600);
	// });

	/* Sticky Header */	
	// if($('.active-sticky-header').length){
	// 	$window.on('resize', function(){
	// 		setHeaderHeight();
	// 	});

	// 	function setHeaderHeight(){
	//  		$("header.main-header").css("height", $('header .header-sticky').outerHeight());
	// 	}	
	
	// 	$window.on("scroll", function() {
	// 		var fromTop = $(window).scrollTop();
	// 		setHeaderHeight();
	// 		var headerHeight = $('header .header-sticky').outerHeight()
	// 		$("header .header-sticky").toggleClass("hide", (fromTop > headerHeight + 100));
	// 		$("header .header-sticky").toggleClass("active", (fromTop > 600));
	// 	});
	// }	
	
		


	/* Init Counter */
	if ($('.counter').length) {
		$('.counter span.number').counterUp({ delay: 5, time: 2000 });
		$('.counter span.numbercta').counterUp({ delay: 5, time: 2000 });
	}	

	/* Animated Wow Js */	
$(document).ready(function () {

    if ($(window).width() < 768) {
        $('.wow').removeClass('wow animated').css({
            'visibility': 'visible',
            'animation-name': 'none'
        });
    } else {
        new WOW().init();
    }

});



	$(document).ready(function() {
       $('.match').matchHeight();
       $('.sameheight').matchHeight();
       $('.growth-platform p').matchHeight();
       $('.card-wrapper-base').matchHeight();
       $('.section-cr p.black-text').matchHeight();
       $('.feature-box p').matchHeight();          
    });

$(window).on("load resize", function () {
    $('.search-growth-card').matchHeight();
    $('.search-growth-card .search-card-content p').matchHeight();
    $('.search-card-content h3').matchHeight();
});

	// const $header = $('.header'); // Adjust selector to match your header
	// console.log($header.outerHeight());


$('a[href^="#"]').on('click', function(e) {
    e.preventDefault();
    const target = $(this.hash);
    const $header = $('.header'); // Adjust selector to match your header
	//console.log(`header Height: ${$header.outerHeight()}`);
	
    if (target.length) {
        const offset = $header.outerHeight() - 1; // Dynamic header height
        $('html, body').animate({
            scrollTop: target.offset().top - offset
        }, 1000);
    }
});




(function() {
  function initSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initSwiper, 100);
      return;
    }
    
    // Use .marketing-swiper class (works everywhere)
    const swiper = new Swiper('.marketing-swiper', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.marketing-pagination',
        clickable: true,
      },     
      navigation: false,      
      breakpoints: {
        767: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        990: { slidesPerView: 3 },
        1200: { slidesPerView: 4 }
      }
    });
  }
  initSwiper();
})();



document.addEventListener('DOMContentLoaded', () => {
console.log('hi');
	
  const scroller = document.querySelector('.dp-work-scroller');
  const track = document.querySelector('.rfm-initial-child-container');
  const items = track.querySelectorAll('.dp-work-scroller__item');
  
  if (items.length < 2) return;

  // Clone items for seamless loop (3x total)
  Array.from(items).forEach(() => {
    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.style.opacity = '1'; // Ensure visible
      track.appendChild(clone);
    });
  });

  let position = 0;
  let animationFrame;
  const speed = 0.5;
  const totalWidth = track.scrollWidth / 4; // Original items width

  function marquee() {
    position -= speed;
    
    // Smooth reset - only when FIRST set of items is fully off-screen
    if (position <= -totalWidth) {
      position += totalWidth; // Seamless jump
    }
    
    track.style.transform = `translateX(${position}px)`;
    animationFrame = requestAnimationFrame(marquee);
  }


    marquee(); // Start animation after 5 seconds


  // Pause controls
  scroller.addEventListener('mouseenter', () => cancelAnimationFrame(animationFrame));
  scroller.addEventListener('mouseleave', marquee);
  scroller.addEventListener('touchstart', () => cancelAnimationFrame(animationFrame));
  scroller.addEventListener('touchend', marquee);
});


document.addEventListener('DOMContentLoaded', function() {
  console.log('hi');  

  const headerMenu = document.querySelector('header-menu');
  if (headerMenu) {
    headerMenu.style.setProperty('--submenu-animation-speed', '0ms', 'important');
    headerMenu.style.setProperty('--submenu-height', 'auto', 'important');
    headerMenu.style.setProperty('--submenu-opacity', '1', 'important');
  }
});


// document.querySelectorAll('.icon-caret').forEach(function(icon) {
//   icon.addEventListener('click', function(e) {   
//     e.preventDefault();
//     e.stopPropagation();

//     const details = this.closest('details');
//     if (details) {
//       details.open = !details.open;
//     }
//   });
// });

	
})(jQuery);


if (!customElements.get('product-recommendations')) {

  class ProductRecommendations extends HTMLElement {

    connectedCallback() {

      const url = this.dataset.url;

      if (!url) return;

      fetch(url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');

          html.innerHTML = text;

          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim()) {

            this.innerHTML = recommendations.innerHTML;

          }

        })
        .catch(error => {
          console.error('Recommendations Error:', error);
        });

    }

  }

  customElements.define(
    'product-recommendations',
    ProductRecommendations
  );

}



setInterval(function () {
    const el = document.getElementById("subify-widget-subscription-text");

    if (el && el.innerText !== "Subscribe and Save (Re-Occurring Charge)") {
        el.innerText = "Subscribe and Save (Re-Occurring Charge)";
    }
}, 500);


// scrollTopBtn
 const scrollTopBtn = document.getElementById("scrollTopBtn");
  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      scrollTopBtn.classList.add("show");
    } else {
      scrollTopBtn.classList.remove("show");
    }
  });

  // scrollTopBtn.addEventListener("click", function () {
  //   const startPosition = window.pageYOffset;
  //   const duration = 600;
  //   const startTime = performance.now();

  //   function scrollAnimation(currentTime) {
  //     const elapsed = currentTime - startTime;
  //     const progress = Math.min(elapsed / duration, 1);

  //     // Ease-out effect
  //     const ease = 1 - Math.pow(1 - progress, 3);

  //     window.scrollTo(0, startPosition * (1 - ease));

  //     if (progress < 1) {
  //       requestAnimationFrame(scrollAnimation);
  //     }
  //   }

  //   requestAnimationFrame(scrollAnimation);
  // });


  function scrollToTop() {
  const startPosition = window.pageYOffset;
  const duration = 600;
  const startTime = performance.now();

  function scrollAnimation(currentTime) {
    const progress = Math.min(
      (currentTime - startTime) / duration,
      1
    );

    const ease = 1 - Math.pow(1 - progress, 3);

    window.scrollTo(0, startPosition * (1 - ease));

    if (progress < 1) {
      requestAnimationFrame(scrollAnimation);
    }
  }

  requestAnimationFrame(scrollAnimation);
}

document.querySelectorAll(".scroll-to-top").forEach(button => {
  button.addEventListener("click", scrollToTop);
});